import api from "./API";
import ApiEndpointConstants from "../constants/ApiEndpointConstants";

export const upload = (file, snCode) => {
  return api.post(`${ApiEndpointConstants.UPLOAD}`, { file, snCode: snCode });
};

export const uploadVideo = (blob, snCode, filePrefix = "face-video") => {
  const mimeType = blob?.type || "video/webm";
  const extension = mimeType.toLowerCase().includes("mp4") ? "mp4" : "webm";
  const file =
    blob instanceof File
      ? blob
      : new File([blob], `${filePrefix}.${extension}`, { type: mimeType });

  const formData = new FormData();
  formData.append("file", file);
  formData.append("snCode", snCode);

  return api.post(ApiEndpointConstants.UPLOAD, formData);
};

/**
 * 上传一段视频分片。
 *
 * 字段名必须与 Uploadzip/upload_chunk 接口保持一致：
 * file、name、index、total、folderName、snCode。
 */
export const uploadVideoChunk = ({
  chunk,
  snCode,
  folderName,
  chunkIndex,
  totalChunks,
  fileName,
  mimeType,
  signal,
}) => {
  const chunkFile = new File([chunk], fileName, {
    type: mimeType || "application/octet-stream",
  });
  const formData = new FormData();

  formData.append("file", chunkFile);
  formData.append("name", fileName);
  formData.append("index", String(chunkIndex));
  formData.append("total", String(totalChunks));
  formData.append("folderName", folderName);
  formData.append("snCode", snCode);

  return api.post(ApiEndpointConstants.VIDEO_CHUNK_UPLOAD, formData, {
    signal,
    // 参考页面使用 fetch 默认配置，不携带跨域 Cookie。
    withCredentials: false,
  });
};

/**
 * 所有分片上传成功后，通知服务端合并文件并生成压缩包。
 */
export const mergeAndZipVideoChunks = ({ folderName, snCode, signal }) => {
  const formData = new FormData();

  formData.append("folderName", folderName);
  formData.append("snCode", snCode);

  return api.post(ApiEndpointConstants.VIDEO_CHUNK_MERGE, formData, {
    signal,
    withCredentials: false,
  });
};
